import { all, takeLatest } from 'redux-saga/effects';

import {
  changePlayersBranchAction,
  createPlayerAction,
  deletePlayerAction,
  getChildPlayersAction,
  getPlayerAction,
  getPlayersInClassAction,
  getPlayersAction,
  reactivePlayerAction,
  updatePlayerMemberCardAction,
  updatePlayerAction,
} from '@/redux/actions';

import { changePlayersBranchSaga } from './change-players-branch';
import { createPlayerSaga } from './create-player';
import { deletePlayerSaga } from './delete-player';
import { getChildPlayersSaga } from './get-child-players';
import { getPlayerSaga } from './get-player';
import { getPlayersInClassSaga } from './get-players-in-class';
import { getPlayersSaga } from './get-players';
import { reactivePlayerSaga } from './reactive-player';
import { updatePlayerMemberCardSaga } from './update-player-member-card';
import { updatePlayerSaga } from './update-player';

export default function* root(): Generator {
  yield all([
    takeLatest(changePlayersBranchAction.request.type, changePlayersBranchSaga),
    takeLatest(createPlayerAction.request.type, createPlayerSaga),
    takeLatest(deletePlayerAction.request.type, deletePlayerSaga),
    takeLatest(getChildPlayersAction.request.type, getChildPlayersSaga),
    takeLatest(getPlayerAction.request.type, getPlayerSaga),
    takeLatest(getPlayersInClassAction.request.type, getPlayersInClassSaga),
    takeLatest(getPlayersAction.request.type, getPlayersSaga),
    takeLatest(reactivePlayerAction.request.type, reactivePlayerSaga),
    takeLatest(updatePlayerMemberCardAction.request.type, updatePlayerMemberCardSaga),
    takeLatest(updatePlayerAction.request.type, updatePlayerSaga),
  ]);
}
